/* 🤖 this file was generated by svg-to-ts */
export const matIconDetails: {
  name: 'details';
  data: string;
} = {
  name: 'details',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 3 2 21h20L12 3zm1 5.92L18.6 19H13V8.92zm-2 0V19H5.4L11 8.92z"/></svg>`
};
